import { useEffect, useState } from "react";
import { auth } from "../utils/firebase/setupFirebase";
import { useDispatch } from "react-redux";
import { setUser } from "../redux/slice/auth";

export const useFirebaseAuth = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setIsLoading(true);
      dispatch(setUser(user));
    });
    //eslint-disable-next-line  react-hooks/exhaustive-deps
  }, []);

  return isLoading;
};
